'use-client';
import { Box, Flex, Grid, SimpleGrid, Text, Image } from "@chakra-ui/react";
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import config from '@config';
import KarmaSliderComponent from "./KarmaSliderComponent";
import ContentArea from "./ContentArea";
import Link from "next/link";
import { useBreakpointValue } from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';
import { useEffect, useState } from "react";
import SimpleButton from "./Buttons/SimpleButton";
import { modifyDatoImgUrlToStatic } from "./utils";


let KarmaLeftSliderCardContent = ({ sectionContent, styleConfig, sectionId }) => {

    let whyKarmaComponent = sectionId === 'why-karma'
    

    const [isMobile, setIsMobile] = useState(null);

    useEffect(() => {
        const checkIsMobile = () => setIsMobile(window.innerWidth < 768);
        checkIsMobile();
        window.addEventListener('resize', checkIsMobile);
        return () => window.removeEventListener('resize', checkIsMobile);
    }, []);

    const imageSrc = useBreakpointValue({
        base: modifyDatoImgUrlToStatic(sectionContent?.[whyKarmaComponent ? 1 : 2]?.mobileImage?.url),
        md: modifyDatoImgUrlToStatic(sectionContent?.[whyKarmaComponent ? 1 : 2]?.tabletImage?.url),
        lg: modifyDatoImgUrlToStatic(sectionContent?.[whyKarmaComponent ? 1 : 2]?.tabletImage?.url),
        xl: modifyDatoImgUrlToStatic(sectionContent?.[whyKarmaComponent ? 1 : 2]?.image?.url)
    });


    return <Box 
        pos={'relative'}
        height={whyKarmaComponent ? 'auto' : { base: 'auto', md: 'auto', lg: 'auto', xl: '942px' }}
        bg={'#EFE7D6'}
        w={'100%'}
        pt={whyKarmaComponent ? {base:'50px', md: '90px', lg: '70px'} : { base: '20px', md: '100px', lg: '100px', xl: '140px' }}
        pb={whyKarmaComponent ? {base:'40px', md: '80px', lg: '70px'} :{ base: '60px', md: '100px', lg: '100px', xl: '0px' }}
        zIndex={2}
    >
        <LazyLoadImageComponent
            display={whyKarmaComponent ? 'block' : { base: 'none', md: 'block' }}
            pos={'absolute'}
            top={'0px'}
            right={'0px'}
            width={{base:'100%', lg: '100%', xl: "auto" }}
            src={imageSrc}
            zIndex={0}
        />
        <Grid templateColumns={whyKarmaComponent ? '1fr' : { md: '1fr', lg: '1fr', xl: "1fr 1fr" }} gap={{ base: 0, md: 20 }}>
            {whyKarmaComponent ? null : <Box display={'flex'} flexDirection={{ base: 'column', md: 'row' }}
                justifyContent={{ base: 'center', md: "center", lg: 'center', xl: 'right' }} alignItems={'center'}>
                <Box mb={{base: '0px', md:'-20px'}} display={{ base: 'block', md: 'none' }} className="mobBookContent">
                    <ContentArea
                        tAlign={'center'}
                        fontFamily={'var(--AustinMedium)'}
                        mainContent={sectionContent?.[3]?.body?.value}
                        sectionContent={sectionContent?.[3]?.body}
                        fontWeight={500}
                        font={{ base: '34px' }}
                    />
                </Box>
                <KarmaSliderComponent sectionContent={sectionContent?.[0]}
                    width={{ base: '292px', md: '483px', lg: '483px', 'xl': '486px' }}
                    height={{ base: '401px', md: '668px', lg: '668px', 'xl': '662px' }}
                />
            </Box>
            }
            <Box
                display={'flex'}
                justifyContent={{ base: 'center', md: 'center', lg: 'center', xl: whyKarmaComponent ? 'center' : 'left' }}
                alignItems={{ base: 'center', md: 'center', lg: 'center', xl: whyKarmaComponent ? 'center' : "start" }}
                flexDir={'column'}
                zIndex={1} className="bookContent"
                mt={'10px'}
            >
                <Box
                    width={whyKarmaComponent ? {base: '95%', md:'690px', lg: '800px'} : {base: '95%', md: '688px', lg: '658px', xl: '560px' }}
                >
                    <Box display={{ base: 'none', md: 'block' }} mt={{ md: '-1rem', lg: "-1rem", xl: '1rem' }} mb={{ md: '-1rem', lg: '0.3rem', xl: '0.3rem' }}>
                        <ContentArea
                            tAlign={'left'}
                            fontFamily={'var(--AustinMedium)'}
                            mainContent={sectionContent?.[3]?.body?.value}
                            sectionContent={sectionContent?.[3]?.body}
                            fontWeight={500}
                            color={"#B7870C"}
                            maxW={'100%'}
                        />
                    </Box>
                    <ContentArea
                        tAlign={'left'}
                        fontFamily={'var(--FedraSansStd-book)'}
                        color={'#000000'}
                        mainContent={sectionContent?.[whyKarmaComponent ? 0 : 1]?.titleBody?.value}
                        sectionContent={sectionContent?.[whyKarmaComponent ? 0 : 1]?.titleBody}
                        font={{ base: '16px', md: '20px' }}
                        fontWeight={400}
                        lineHeight={{base:'26px', md:"34px"}}
                        maxW={'100%'}
                    />
                    {whyKarmaComponent ? undefined :
                        <SimpleButton sectionContent={sectionContent?.[1]?.cta?.[0]} />}
                </Box>
            </Box>
        </Grid>
        {isMobile !== null && (
        <style>
            {`
            .bookContent h1 {
                font-size: 60px !important;
            }
                .bookContent p:empty {
                margin-bottom: ${isMobile ? '1rem' : '2rem'};
            }
                .mobBookContent h1 {
                font-size: 34px !important;
                color: #B7870C;
            }
            ${whyKarmaComponent ? `
                .bookContent h1 {
                    font-family: var(--AustinMedium);
                    font-weight: 500 !important;
                    padding-bottom: ${isMobile ? '0.4rem' : '1rem'} !important;
                    font-size: ${isMobile ? '34px' : '60px'} !important;
                    color: #B7870C !important;
                }
                ` : null}
            `}
        </style>)}
    </Box>

}

export default KarmaLeftSliderCardContent;